import { themeTools } from 'native-base';

export const SwitchTheme = {
    Switch: {
        baseStyle: (props) => ({
            size: "xs",
            _text: {
                textTransform: "uppercase"
            },

            onTrackColor: props.onTrackColor
                ?? themeTools.mode(
                    'gray.400',
                    'gray.600'
                )(props),
        })
    }
}